import styled from "styled-components";
import { Input, Select ,DatePicker} from "antd";

// Styled Input Component
const StyledInput = styled(Input)`
  // line-height: 2.5714285714285714; 
  // border-radius: 3px; 
  font-family: 'Roboto', sans-serif;
  border-color: 1px solid #BDBDBD;
  color:black;

  &.ant-input {
    border: 1px solid #BDBDBD; /* Default border color */
    box-shadow: none; /* Remove default box-shadow */
    transition: border-color 0.3s ease, box-shadow 0.3s ease; /* Smooth transition for border color and shadow */
  }

  &.ant-input:hover,
  &.ant-input:focus {
    border-color: #ffc2e0; /* Border color on hover and focus */
    box-shadow: 0 0 0 1px rgba(255, 133, 192, 0.1); /* Optional: Pink shadow on focus */
  }

  &.ant-input:active,
  &.ant-input:focus-visible {
    border-color: #ffc2e0; /* Border color when active (clicked) */
    box-shadow: 0 0 0 1px rgba(255, 133, 192, 0.1); /* Optional: Pink shadow on focus */
  }

  .ant-input-prefix,
  .ant-input-suffix {
    color: #ffc2e0; /* Icon color if you have prefixes/suffixes */
  }
`;
const StyledPasswordInput = styled(Input.Password)`
  // line-height: 2.5714285714285714; 
  // border-radius: 3px;
  font-family: 'Roboto', sans-serif;
  border-color: 1px solid #BDBDBD;
  color:black;
  
  &.ant-input-password {
    box-shadow: none; /* Remove default box-shadow */
    border: 1px solid #BDBDBD; /* Default border color */
    outline: none; /* Remove default outline */
    transition: border-color 0.3s ease, box-shadow 0.3s ease; /* Smooth transition */
  }

  &.ant-input-password:hover,
  &.ant-input-password:focus {
    border-color: #ffc2e0; /* Border color on hover and focus */
    box-shadow: 0 0 0 1px rgba(255, 133, 192, 0.1); /* Optional: Pink shadow on focus */
    outline: none; /* Remove outline on focus */
  }

  &.ant-input-password:active,
  &.ant-input-password:focus-visible {
    border-color: #ffc2e0; /* Border color when active (clicked) */
    box-shadow: 0 0 0 1px rgba(255, 133, 192, 0.1); /* Optional: Pink shadow on focus */
    outline: none; /* Remove outline on focus-visible */
  }

  .ant-input-prefix,
  .ant-input-suffix {
    color: #ffc2e0; /* Icon color if you have prefixes/suffixes */
  }
`;

const StyledSelect = styled(Select)`
  &.ant-select {
    .ant-select-selector {
      border: 1px solid #BDBDBD !important; /* Default border color */
      box-shadow: none !important; /* Remove default box-shadow */
      transition: border-color 0.3s ease, box-shadow 0.3s ease; /* Smooth transition */
      outline: none !important; /* Remove default outline */
    }

    &.ant-select-focused .ant-select-selector,
    &.ant-select-selector:focus,
    &.ant-select-selector:active {
      border-color: #ffc2e0 !important; /* Lighter pink border color on focus/active */
      box-shadow: 0 0 0 1px rgba(255, 194, 224, 0.1) !important; /* Lighter pink shadow */
      outline: none !important; /* Remove outline on focus */
    }

    &.ant-select-open .ant-select-selector {
      border-color: #ffc2e0 !important; /* Lighter pink border color when the dropdown is open */
      box-shadow: 0 0 0 1px rgba(255, 194, 224, 0.1) !important; /* Lighter pink shadow on open */
    }

    &.ant-select-selector:active,
    &.ant-select-selector:focus-visible {
      border-color: #ffc2e0 !important; /* Lighter pink border color when active */
      box-shadow: 0 0 0 1px rgba(255, 194, 224, 0.1) !important; /* Lighter pink shadow */
      outline: none !important; /* Remove outline */
    }

    .ant-select-arrow {
      color: lightgrey; /* Default arrow color */
      transition: color 0.3s ease; /* Smooth transition for color */
    }

    &.ant-select-focused .ant-select-arrow,
    &.ant-select-open .ant-select-arrow {
      color: #ffc2e0 !important; /* Lighter pink arrow color when focused or open */
    }

    /* Remove blue background and apply custom styles */
    .ant-select-item-option-selected {
      background-color: #ffc2e0 !important; /* Lighter pink background for selected item */
      color: white !important; /* Text color for selected item */
      outline: none !important; /* Remove focus outline */
      box-shadow: none !important; /* Remove any box shadow */
    }

    /* Remove blue highlight on hover and apply custom styles */
    .ant-select-item-option-active {
      background-color: #ffd6eb !important; /* Slightly darker pink for hovered item */
      color: black !important; /* Text color for hovered item */
      outline: none !important; /* Remove focus outline */
      box-shadow: none !important; /* Remove any box shadow */
    }
    .ant-select-selection {
    background-color: green;
    }

    /* Override native focus and active state styles */
    .ant-select-item-option-active:focus,
    .ant-select-item-option-active:active,
    .ant-select-item-option-selected:focus,
    .ant-select-item-option-selected:active {
      background-color: #ffc2e0 !important; /* Ensure pink background when focused or active */
      color: white !important; /* Ensure text color stays white */
      outline: none !important; /* Remove blue outline */
      box-shadow: none !important; /* Remove any default shadows */
    }
  }
`;

const StyledDatePicker = styled(DatePicker)`
  font-family: 'Roboto', sans-serif;
  border-color: #BDBDBD;
  color: black;

  &.ant-picker {
    border: 1px solid #BDBDBD; /* Default border color */
    box-shadow: none; /* Remove default box-shadow */
    transition: border-color 0.3s ease, box-shadow 0.3s ease; /* Smooth transition */
  }

  &.ant-picker:hover,
  &.ant-picker:focus {
    border-color: #ffc2e0; /* Border color on hover and focus */
    box-shadow: 0 0 0 1px rgba(255, 133, 192, 0.1); /* Optional: Pink shadow on focus */
  }

  &.ant-picker:active,
  &.ant-picker:focus-visible {
    border-color: #ffc2e0; /* Border color when active (clicked) */
    box-shadow: 0 0 0 1px rgba(255, 133, 192, 0.1); /* Optional: Pink shadow on focus */
  }

  .ant-picker-input {
    color: black; /* Input text color */
  }

  .ant-picker-suffix {
    color: lightgrey; /* Icon color */
  }

  .ant-picker-input:hover,
  .ant-picker-input:focus {
    color: #BDBDBD; /* Input text color on hover/focus */
  }
`;

export { StyledInput, StyledPasswordInput, StyledSelect ,StyledDatePicker};
